import { h, Component } from 'preact';

const IS_IE = isIE();

//fallbacks to jpg in case of ie, uses svg otherwhise
export default function illustration (props) {
  const image = IS_IE ? props.src + '.jpg' : props.src + '.svg';

  return <img alt={ props.alt } src={ image } />;
};

function isIE() {

  let ua = window.navigator.userAgent,
      msie = ua.indexOf("MSIE ");

  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
  {
    return true;
  }

  return false;
}


// WEBPACK FOOTER //
// ./ts/illustration.tsx